import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useZodFormContext } from './context.js';
export function When({ field, eq, neq, when, children, fallback = null, }) {
    const { form } = useZodFormContext();
    const value = form.watch(field);
    let show = true;
    if (when)
        show = when(value);
    else if (eq !== undefined)
        show = value === eq;
    else if (neq !== undefined)
        show = value !== neq;
    else
        show = Boolean(value);
    return _jsx(_Fragment, { children: show ? children : fallback });
}
//# sourceMappingURL=when.js.map